module.exports = __webpack_public_path__ + "static/media/oberflex-hetreetuve-2560x1440.762281d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-hetreetuve-2560x1440.jpg
// module id = 1029
// module chunks = 37